<ngb-pagination
  #pagination
  class="pagination"
  [collectionSize]="config.totalDocs"
  [pageSize]="config.limit"
  class="pt-3"
  (pageChange)="changePageDetect(page)"
  >
  <ng-template ngbPaginationPrevious>
    <i class="datatable-icon-left" style="padding-top: 4px;"></i>
  </ng-template>
  <ng-template ngbPaginationNext>
    <i class="datatable-icon-right" style="padding-top: 4px;"></i>
  </ng-template>
</ngb-pagination>

<!-- <ngb-pagination
  [collectionSize]="config.totalDocs || 0"
  [(page)]="config.page"
  [directionLinks]="false"
  aria-label="Default pagination"
></ngb-pagination> -->

<!-- (pageChange)="getCustomers()" -->
